export const isOneShopLayout = (layoutType: string) =>
  layoutType === 'one-shop';
